import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import ReactPlayer from 'react-player';
import grandBooth from '../../assets/jss/components/grandBooth';
import WrapperContainer from '../../components/Container/WrapperContainer';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { MEDIA_TYPE } from '../../common/Constants';
import {
    ZoomIn,
    PrevIcon,
    NextIcon,
    CancelIconDialog,
} from '../../components/Icons/Icon';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(grandBooth);

const GrandBoothProductItemCustomLayout = (props) => {
    const {
        product,
        productActive,
        token,
    } = props;
    const classes = useStyles(props);
    const intl = useIntl();
    const [isOpenSliderImage, setIsOpenSliderImage] = useState(false);
    const [indexProductActive, setIndexProductActive] = useState(0);
    const handleViewImage = (e, index) => {
        e.stopPropagation();
        setIndexProductActive(index);
        setIsOpenSliderImage(true);
    };

    const renderProductItem = (productItem, index) => (
        <GridItem xs={12} sm={6} md={4} lg={4} className={classes.layoutFirstItem} key={+`${productItem.id}${index}`}>
            <article className={classes.layoutFirstProduct} onClick={() => productActive(index)}>
                <div className={classes.layoutFirstProductThumbnail} title={productItem.name}>
                    <>
                        <p
                            className={classes.layoutFirstProductItemIcon}
                            onClick={(e) => handleViewImage(e, index)}
                        >
                            <ZoomIn size="30px" />
                        </p>
                        {productItem.media_type === MEDIA_TYPE.IMAGE && (
                            <img
                                src={productItem.media}
                                alt={productItem.name}
                                className={classes.productItemImg}
                            />
                        )}
                        {productItem.media_type === MEDIA_TYPE.AUDIO && (
                            <img
                                src="/resources/audio_image.png"
                                alt=""
                                className={classes.layoutFirstProductItem}
                            />
                        )}
                        {productItem.media_type === MEDIA_TYPE.VIDEO && (
                            <img
                                src="/resources/video_image.png"
                                alt=""
                                className={classes.layoutFirstProductItem}
                            />
                        )}
                    </>
                </div>
                <div className={classes.layoutFirstProductMeta}>
                    <div className={classes.layoutFirstProductName}>
                        <h2 className={classes.layoutFirstProductItemName} title={productItem.name}>{productItem.name}</h2>
                    </div>
                    <div className={classes.productPrice}>
                        {`${intl.formatNumber(productItem.price)}${intl.formatMessage({ id: 'common.yen' })}`}
                    </div>
                </div>
            </article>
        </GridItem>
    );

    const prevProduct = () => {
        if (indexProductActive !== 0) {
            setIndexProductActive(+indexProductActive - 1);
        }
    };

    const nextProduct = () => {
        if (indexProductActive !== +product.length - 1) {
            setIndexProductActive(+indexProductActive + 1);
        }
    };

    const slideImageProduct = () => (
        <Dialog open={isOpenSliderImage} onClose={() => setIsOpenSliderImage(false)} classes={{ root: classes.rootLayout }}>
            <div className={classes.productSlider}>
                {platform === PLATFORM.OTHER ? (
                    <>
                        <p
                            onClick={() => prevProduct()}
                            className={indexProductActive === 0 ? classes.productSliderArrowDisable : classes.productSliderArrow}
                        >
                            <PrevIcon color="#fff" size="60px" />
                        </p>
                        <p
                            onClick={() => nextProduct()}
                            className={indexProductActive === +product.length - 1 ? classes.productSliderNextArrowDisable : classes.productSliderNextArrow}
                        >
                            <NextIcon color="#fff" size="60px" />
                        </p>
                    </>
                ) : (
                    <>
                        <p
                            onClick={() => prevProduct()}
                            className={indexProductActive === 0 ? classes.productSliderArrowDisableMobile : classes.productSliderArrowMobile}
                        >
                            <PrevIcon color="#fff" size="50px" />
                        </p>
                        <p
                            onClick={() => nextProduct()}
                            className={indexProductActive === +product.length - 1 ? classes.productSliderNextArrowDisableMobile : classes.productSliderNextArrowMobile}
                        >
                            <NextIcon color="#fff" size="50px" />
                        </p>
                    </>
                )}

                <div className={classes.sliderFirst}>
                    {product[indexProductActive].media_type === MEDIA_TYPE.IMAGE && (
                        <img
                            src={product[indexProductActive].media}
                            alt=""
                            className={classes.imgStyle}
                        />
                    )}
                    {product[indexProductActive].media_type === MEDIA_TYPE.AUDIO
                        && (
                            <>
                                <ReactPlayer
                                    controls
                                    config={{
                                        attributes: {
                                            controlsList: 'nodownload',
                                            style: {
                                                outline: 'none',
                                                margin: 'auto',
                                                maxHeight: '100%',
                                                maxWidth: 'calc(100% - 120px)',
                                            },
                                        },
                                        forceAudio: true,
                                    }}
                                    width="100%"
                                    url={(product[indexProductActive].media && token) && `${product[indexProductActive].media}?token=${token}`}
                                    style={{ display: 'flex', margin: 'auto' }}
                                />
                            </>
                        )}
                    {product[indexProductActive].media_type === MEDIA_TYPE.VIDEO
                        && (
                            <ReactPlayer
                                controls
                                config={{
                                    attributes: {
                                        controlsList: 'nodownload',
                                        style: {
                                            outline: 'none',
                                            margin: 'auto',
                                            maxHeight: '645px',
                                            maxWidth: '100%',
                                        },
                                    },
                                }}
                                width="100%"
                                height="auto"
                                url={(product[indexProductActive].media && token) && `${product[indexProductActive].media}?token=${token}`}
                                style={{ display: 'flex', margin: 'auto' }}
                            />
                        )}
                </div>
                <div className={classes.productSliderInfoProduct}>
                    <p className={classes.productSliderInfoProductName}>{product[indexProductActive].name}</p>
                    <p>{`${intl.formatNumber(product[indexProductActive].price)}${intl.formatMessage({ id: 'common.yen' })}`}</p>
                </div>
            </div>
            <IconButton aria-label="close" className={classes.CloseBtn} onClick={() => setIsOpenSliderImage(false)}>
                <CancelIconDialog />
            </IconButton>
        </Dialog>
    );

    return (
        <>
            <WrapperContainer>
                <GridItem xs={12} className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER })}>
                    <GridContainer>
                        {product.map((productItem, index) => renderProductItem(productItem, index))}
                        {slideImageProduct()}
                    </GridContainer>
                </GridItem>
            </WrapperContainer>
        </>
    );
};

GrandBoothProductItemCustomLayout.defaultProps = {
    product: {},
    productActive: () => {},
    token: '',
};

GrandBoothProductItemCustomLayout.propTypes = {
    product: PropTypes.oneOfType([() => null, PropTypes.object]),
    productActive: PropTypes.func,
    token: PropTypes.string,
};

export default GrandBoothProductItemCustomLayout;
